/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font } from "@react-pdf/renderer";
import Strings from "../utilities/StringSelector";

// Register Roboto Font
Font.register({ family: "RobotoRegular", src: process.env.PUBLIC_URL + "/fonts/roboto-v20-latin-regular.ttf" });
Font.register({ family: "RobotoMedium", src: process.env.PUBLIC_URL + "/fonts/Roboto-Medium.ttf" });

export class SuggestedActionsReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      generatingDate: new Date(),
      // The report itself
      doc: ""
    };

  }

  // ------------------------ Utilities -------------------------
  getDateNow = () => {
    return (
      this.state.generatingDate.getDate()
      + "/"
      + (this.state.generatingDate.getMonth() + 1)
      + "/"
      + this.state.generatingDate.getFullYear()
    );
  }

  getPageTitle = (errorType) => {
    if (errorType === "alignmentErrorsNotZero") {
      return Strings.ALIGNMENT_ERRORS_PAGE_TITLE;
    }
    else if (errorType === "carrierSenseErrors") {
      return Strings.CARRIER_SENSE_ERRORS_PAGE_TITLE;
    }
    else if (errorType === "fcsErrorsNotZero") {
      return Strings.FCS_ERRORS_PAGE_TITLE;
    }
    else if (errorType === "singleCollisionsNotZero") {
      return Strings.SINGLE_COLLISIONS_PAGE_TITLE;
    }
    else if (errorType === "multipleCollisionsNotZero") {
      return Strings.MULTIPLE_COLLISIONS_PAGE_TITLE;
    }
    else if (errorType === "lateCollisionsNotZero") {
      return Strings.LATE_COLLISIONS_PAGE_TITLE;
    }
    else if (errorType === "excessiveCollisionsNotZero") {
      return Strings.EXCESSIVE_COLLISIONS_PAGE_TITLE;
    }
    else if (errorType === "deferredTransmissionNotZero") {
      return Strings.DEFERRED_TRANSMISSIONS_PAGE_TITLE;
    }
    else if (errorType === "frameTooLongNotZero") {
      return Strings.FRAME_TOO_LONG_PAGE_TITLE;
    }
    else if (errorType === "macTransmitErrorsNotZero") {
      return Strings.MAC_TRANSMIT_ERRORS_PAGE_TITLE;
    }
    else if (errorType === "macReceiveErrorsNotZero") {
      return Strings.MAC_RECEIVE_ERRORS_PAGE_TITLE;
    }
    else if (errorType === "inDiscardsNotZero") {
      return Strings.IN_DISCARDS_PAGE_TITLE;
    }
    else if (errorType === "inErrorsNotZero") {
      return Strings.IN_ERRORS_PAGE_TITLE;
    }
    else if (errorType === "inUnknownProtosNotZero") {
      return Strings.IN_UNKNOWN_PROTOS_PAGE_TITLE;
    }
    else if (errorType === "outDiscardsNotZero") {
      return Strings.OUT_DISCARDS_PAGE_TITLE;
    }
    else if (errorType === "outErrorsNotZero") {
      return Strings.OUT_ERRORS_PAGE_TITLE;
    }
  }

  // ----------------- Header for all the pages -----------------
  getPageHeader = () => {
    return (
      <View fixed>
        <View style={headerStyles.container}>
          <Image src={process.env.PUBLIC_URL + "/logo_report.png"} style={headerStyles.logo} />
          <Text style={headerStyles.text}>{Strings.SUGGESTED_ACTIONS_HEADER_TEXT}</Text>
        </View>
        <View style={headerStyles.line}></View>
      </View>
    );
  }

  // ----------------- Footer for all the pages -----------------
  getPageFooter = () => {
    return (
      <View style={footerStyles.container} fixed>
        <View style={footerStyles.line}></View>
        <View>
          <Text style={footerStyles.text} render={({ pageNumber, totalPages }) => {
            return (`${this.getDateNow()}, ${Strings.REPORT_PAGE} ${pageNumber} / ${totalPages}`);
          }} fixed />
        </View>
      </View>
    );
  }

  // ----------------- Generate Report --------------------------
  createReport = () => {
    let doc = <Document
      title={Strings.SUGGESTED_ACTIONS_HEADER_TEXT}>
      {this.createIntroPage()}
      {this.createSummaryPage()}
      {this.createSuggestionPages()}
      {this.createSuggestionPages2()}
      {this.createSuggestionPages3()}
      {this.createSuggestionPages4()}
      {this.createSuggestionPages5()}
      {this.createSuggestionPages6()}
      {this.createDisclaimerPage()}
    </Document>;

    return doc;
  }

  createIntroPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "28vh" }} />

        <View style={reusableStyles.mainTitleUpperLine} />

        <Text style={reusableStyles.mainTitle}>
          {Strings.SUGGESTED_ACTIONS_REPORT_TITLE}
        </Text>

        <Text style={reusableStyles.mainTitle2}>
          {Strings.SUGGESTED_ACTIONS_REPORT_SUBTITLE}
        </Text>

        <View style={reusableStyles.mainTitleBottomLine} />

        {this.getPageFooter()}
      </Page >
    );
  }

  // ---------------------- Summary ----------------------------
  createSummaryPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={false}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.SUMMARY}</Text>

        <Text style={reusableStyles.subHeaderText} fixed>{
          Strings.ACTION_SUGGESTION} - {Strings.MEDIA_COUNTERS}
        </Text>

        <View style={reusableStyles.subHeaderLine} fixed />

        <Text style={reusableStyles.summaryText} fixed>
          1. {Strings.ALIGNMENT_ERROR_HEADER} {Strings.ALIGNMENT_ERRORS_DOTS} {3}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          2. {Strings.CARRIER_SENSE_HEADER} {Strings.CARRIER_SENSE_ERRORS_DOTS} {3}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          3. {Strings.FCS_ERROR_HEADER} {Strings.FCS_ERRORS_DOTS} {3}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          4. {Strings.SINGLE_COLLISION_HEADER} {Strings.SINGLE_COLLISIONS_DOTS} {4}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          5. {Strings.MULTIPLE_COLLISIONS_HEADER} {Strings.MULTIPLE_COLLISIONS_DOTS} {4}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          6. {Strings.LATE_COLLISIONS_HEADER} {Strings.LATE_COLLISIONS_DOTS} {4}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          7. {Strings.EXCESSIVE_COLLISIONS_HEADER} {Strings.EXCESSIVE_COLLISIONS_DOTS} {5}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          8. {Strings.DEFERRED_TRANSMISSION_HEADER} {Strings.DEFERRED_TRANSMISSIONS_DOTS} {5}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          9. {Strings.FRAME_TOO_LONG_HEADER} {Strings.FRAME_TOO_LONG_DOTS} {5}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          10. {Strings.MAC_TRANSMIT_HEADER} {Strings.MAC_TRANSMIT_ERRORS_DOTS} {6}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          11. {Strings.MAC_RECEIVE_HEADER} {Strings.MAC_RECEIVE_ERRORS_DOTS} {6}
        </Text>

        <Text style={reusableStyles.secondSubHeaderText} fixed>
          {Strings.ACTION_SUGGESTION} - {Strings.INTERFACE_COUNTERS}
        </Text>

        <View style={reusableStyles.subHeaderLine} fixed />

        <Text style={reusableStyles.summaryText} fixed>
          12. {Strings.IN_DISCARDS_HEADER} {Strings.IN_DISCARDS_DOTS} {7}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          13. {Strings.IN_ERRORS_HEADER} {Strings.IN_ERRORS_DOTS} {7}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          14. {Strings.IN_UNKNOWN_PROTOS_HEADER} {Strings.IN_UNKNOWN_PROTOS_DOTS} {8}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          15. {Strings.OUT_DISCARDS_HEADER} {Strings.OUT_DISCARDS_DOTS} {8}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          16. {Strings.OUT_ERRORS_HEADER} {Strings.OUT_ERRORS_DOTS} {8}
        </Text>

        <Text style={reusableStyles.secondSubHeaderText} fixed>{Strings.DISCLAIMER}</Text>
        <View style={reusableStyles.subHeaderLine} fixed />

        <Text style={reusableStyles.summaryText} render={({ totalPages }) => (
          `17. ${Strings.DISCLAIMER} ${Strings.INTEFACE_COUNTERS_DISCLAIMER_DOTS} ${totalPages}`
        )} fixed />

        {this.getPageFooter()}

      </Page>
    );
  }

  // ---------------------- Suggestions ----------------------------
  createSuggestionPages = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={suggestionPagesStyles.page}>

        {this.getPageHeader()}

        <Text style={suggestionPagesStyles.pageTitle}>{this.getPageTitle("alignmentErrorsNotZero")}</Text>

        <Text style={reusableStyles.centeredSubHeaderText}>{Strings.ALIGNMENT_ERRORS_SUGGESTION_1}</Text>
        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.lastInfoText}>
          <Text style={reusableStyles.boldText}>{Strings.ALIGNMENT_ERRORS_DP}</Text>
          {Strings.ALIGNMENT_ERRORS_SUGGESTION_2}
        </Text>
        <Text style={reusableStyles.normalText}>
          <Text style={reusableStyles.boldText}>{Strings.COMMON_CAUSES}</Text>
          {Strings.ALIGNMENT_ERRORS_SUGGESTION_3}
        </Text>

        <View style={reusableStyles.subHeaderLine2} />

        <Text style={suggestionPagesStyles.pageTitle2}>{this.getPageTitle("carrierSenseErrors")}</Text>

        <Text style={reusableStyles.centeredSubHeaderText}>{Strings.CARRIER_SENSE_ERRORS_SUGGESTION_1}</Text>
        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.lastInfoText}>
          <Text style={reusableStyles.boldText}>{Strings.CARRIER_SENSE_DP}</Text>
          {Strings.CARRIER_SENSE_ERRORS_SUGGESTION_2}
        </Text>
        <Text style={reusableStyles.normalText}>
          <Text style={reusableStyles.boldText}>{Strings.COMMON_CAUSES}</Text>
          {Strings.CARRIER_SENSE_ERRORS_SUGGESTION_3}
        </Text>

        <View style={reusableStyles.subHeaderLine2} />

        <Text style={suggestionPagesStyles.pageTitle2}>{this.getPageTitle("fcsErrorsNotZero")}</Text>

        <Text style={reusableStyles.centeredSubHeaderText}>{Strings.FCS_ERRORS_SUGGESTION_1}</Text>
        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.lastInfoText}>
          <Text style={reusableStyles.boldText}>{Strings.FCS_ERRORS_DP}</Text>
          {Strings.FCS_ERRORS_SUGGESTION_2}
        </Text>
        <Text style={reusableStyles.normalText}>
          <Text style={reusableStyles.boldText}>{Strings.COMMON_CAUSES}</Text>
          {Strings.FCS_ERRORS_SUGGESTION_3}
        </Text>

        <View style={reusableStyles.subHeaderLine2} />

        {this.getPageFooter()}

      </Page>
    );
  }

  createSuggestionPages2 = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={suggestionPagesStyles.page}>

        {this.getPageHeader()}

        <Text style={suggestionPagesStyles.pageTitle}>{this.getPageTitle("singleCollisionsNotZero")}</Text>

        <Text style={reusableStyles.centeredSubHeaderText}>{Strings.SINGLE_COLLISIONS_SUGGESTION_1}</Text>
        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.lastInfoText}>
          <Text style={reusableStyles.boldText}>{Strings.SINGLE_MULTIPLE_EXCESSIVE_COLLISIONS_DP}</Text>
          {Strings.SINGLE_MULTIPLE_EXCESSIVE_COLLISIONS_SUGGESTION_2}
        </Text>
        <Text style={reusableStyles.normalText}>
          <Text style={reusableStyles.boldText}>{Strings.COMMON_CAUSES}</Text>
          {Strings.SINGLE_MULTIPLE_EXCESSIVE_COLLISIONS_SUGGESTION_3}
        </Text>

        <View style={reusableStyles.subHeaderLine2} />

        <Text style={suggestionPagesStyles.pageTitle2}>{this.getPageTitle("multipleCollisionsNotZero")}</Text>

        <Text style={reusableStyles.centeredSubHeaderText}>{Strings.MULTIPLE_COLLISIONS_SUGGESTION_1}</Text>
        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.lastInfoText}>
          <Text style={reusableStyles.boldText}>{Strings.SINGLE_MULTIPLE_EXCESSIVE_COLLISIONS_DP}</Text>
          {Strings.SINGLE_MULTIPLE_EXCESSIVE_COLLISIONS_SUGGESTION_2}
        </Text>
        <Text style={reusableStyles.normalText}>
          <Text style={reusableStyles.boldText}>{Strings.COMMON_CAUSES}</Text>
          {Strings.SINGLE_MULTIPLE_EXCESSIVE_COLLISIONS_SUGGESTION_3}
        </Text>

        <View style={reusableStyles.subHeaderLine2} />

        <Text style={suggestionPagesStyles.pageTitle2}>{this.getPageTitle("lateCollisionsNotZero")}</Text>

        <Text style={reusableStyles.centeredSubHeaderText}>{Strings.LATE_COLLISIONS_SUGGESTION_1}</Text>
        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.lastInfoText}>
          <Text style={reusableStyles.boldText}>{Strings.LATE_COLLISIONS_DP}</Text>
          {Strings.LATE_COLLISIONS_SUGGESTION_2}
        </Text>
        <Text style={reusableStyles.normalText}>
          <Text style={reusableStyles.boldText}>{Strings.COMMON_CAUSES}</Text>
          {Strings.LATE_COLLISIONS_SUGGESTION_3}
        </Text>

        <View style={reusableStyles.subHeaderLine2} />

        {this.getPageFooter()}

      </Page>
    );
  }

  createSuggestionPages3 = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={suggestionPagesStyles.page}>

        {this.getPageHeader()}

        <Text style={suggestionPagesStyles.pageTitle}>{this.getPageTitle("excessiveCollisionsNotZero")}</Text>

        <Text style={reusableStyles.centeredSubHeaderText}>{Strings.EXCESSIVE_COLLISIONS_SUGGESTION_1}</Text>
        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.lastInfoText}>
          <Text style={reusableStyles.boldText}>{Strings.SINGLE_MULTIPLE_EXCESSIVE_COLLISIONS_DP}</Text>
          {Strings.SINGLE_MULTIPLE_EXCESSIVE_COLLISIONS_SUGGESTION_2}
        </Text>
        <Text style={reusableStyles.normalText}>
          <Text style={reusableStyles.boldText}>{Strings.COMMON_CAUSES}</Text>
          {Strings.SINGLE_MULTIPLE_EXCESSIVE_COLLISIONS_SUGGESTION_3}
        </Text>

        <View style={reusableStyles.subHeaderLine2} />

        <Text style={suggestionPagesStyles.pageTitle2}>{this.getPageTitle("deferredTransmissionNotZero")}</Text>

        <Text style={reusableStyles.centeredSubHeaderText}>{Strings.DEFERRED_TRANSMISSIONS_SUGGESTION_1}</Text>
        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.lastInfoText}>
          <Text style={reusableStyles.boldText}>{Strings.DEFERRED_TRANSMISSIONS_DP}</Text>
          {Strings.DEFERRED_TRANSMISSIONS_SUGGESTION_2}
        </Text>
        <Text style={reusableStyles.normalText}>
          <Text style={reusableStyles.boldText}>{Strings.COMMON_CAUSES}</Text>
          {Strings.DEFERRED_TRANSMISSIONS_SUGGESTION_3}
        </Text>

        <View style={reusableStyles.subHeaderLine2} />

        <Text style={suggestionPagesStyles.pageTitle2}>{this.getPageTitle("frameTooLongNotZero")}</Text>

        <Text style={reusableStyles.centeredSubHeaderText}>{Strings.FRAME_TOO_LONG_SUGGESTION_1}</Text>
        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.lastInfoText}>
          <Text style={reusableStyles.boldText}>{Strings.FRAME_TOO_LONG_DP}</Text>
          {Strings.FRAME_TOO_LONG_SUGGESTION_2}
        </Text>
        <Text style={reusableStyles.normalText}>
          <Text style={reusableStyles.boldText}>{Strings.COMMON_CAUSES}</Text>
          {Strings.FRAME_TOO_LONG_SUGGESTION_3}
        </Text>

        <View style={reusableStyles.subHeaderLine2} />

        {this.getPageFooter()}

      </Page>
    );
  }

  createSuggestionPages4 = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={suggestionPagesStyles.page}>

        {this.getPageHeader()}

        <Text style={suggestionPagesStyles.pageTitle}>{this.getPageTitle("macTransmitErrorsNotZero")}</Text>

        <Text style={reusableStyles.centeredSubHeaderText}>{Strings.MAC_TRANSMIT_ERRORS_SUGGESTION_1}</Text>
        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.lastInfoText}>
          <Text style={reusableStyles.boldText}>{Strings.MAC_TRANSMIT_ERROR_DP}</Text>
          {Strings.MAC_TRANSMIT_ERRORS_SUGGESTION_2}
        </Text>
        <Text style={reusableStyles.normalText}>
          <Text style={reusableStyles.boldText}>{Strings.COMMON_CAUSES}</Text>
          {Strings.MAC_TRANSMIT_ERRORS_SUGGESTION_3}
        </Text>

        <View style={reusableStyles.subHeaderLine2} />

        <Text style={suggestionPagesStyles.pageTitle2}>{this.getPageTitle("macReceiveErrorsNotZero")}</Text>

        <Text style={reusableStyles.centeredSubHeaderText}>{Strings.MAC_RECEIVE_ERRORS_SUGGESTION_1}</Text>
        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.lastInfoText}>
          <Text style={reusableStyles.boldText}>{Strings.MAC_RECEIVE_ERROR_DP}</Text>
          {Strings.MAC_RECEIVE_ERRORS_SUGGESTION_2}
        </Text>
        <Text style={reusableStyles.normalText}>
          <Text style={reusableStyles.boldText}>{Strings.COMMON_CAUSES}</Text>
          {Strings.MAC_RECEIVE_ERRORS_SUGGESTION_3}
        </Text>

        <View style={reusableStyles.subHeaderLine2} />

        {this.getPageFooter()}

      </Page>
    );
  }

  createSuggestionPages5 = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={suggestionPagesStyles.page}>

        {this.getPageHeader()}

        <Text style={suggestionPagesStyles.pageTitle}>{this.getPageTitle("inDiscardsNotZero")}</Text>

        <Text style={reusableStyles.centeredSubHeaderText}>{Strings.IN_DISCARDS_SUGGESTION_1}</Text>
        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.normalSpacedText}>{Strings.IN_DISCARDS_SUGGESTION_2}</Text>
        <Text style={reusableStyles.normalSpacedText}>{Strings.IN_DISCARDS_SUGGESTION_3}</Text>
        <Text style={reusableStyles.normalSpacedText}>{Strings.IN_DISCARDS_SUGGESTION_4}</Text>
        <Text style={reusableStyles.normalSpacedText}>{Strings.IN_DISCARDS_SUGGESTION_5}</Text>
        <Text style={reusableStyles.normalSpacedText}>{Strings.IN_DISCARDS_SUGGESTION_6}</Text>

        <View style={reusableStyles.subHeaderLine2} />

        <Text style={suggestionPagesStyles.pageTitle2}>{this.getPageTitle("inErrorsNotZero")}</Text>

        <Text style={reusableStyles.centeredSubHeaderText}>{Strings.IN_ERRORS_SUGGESTION_1}</Text>
        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.normalSpacedText}>{Strings.IN_ERRORS_SUGGESTION_2}</Text>
        <Text style={reusableStyles.normalSpacedText}>{Strings.IN_ERRORS_SUGGESTION_3}</Text>
        <Text style={reusableStyles.normalSpacedText}>{Strings.IN_ERRORS_SUGGESTION_4}</Text>
        <Text style={reusableStyles.normalSpacedText}>{Strings.IN_ERRORS_SUGGESTION_5}</Text>

        <View style={reusableStyles.subHeaderLine2} />

        {this.getPageFooter()}

      </Page>
    );
  }

  createSuggestionPages6 = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={suggestionPagesStyles.page}>

        {this.getPageHeader()}
        <Text style={suggestionPagesStyles.pageTitle}>{this.getPageTitle("inUnknownProtosNotZero")}</Text>

        <Text style={reusableStyles.centeredSubHeaderText}>{Strings.IN_UNKNOWN_PROTOS_SUGGESTION_1}</Text>
        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.normalSpacedText}>
          <Text style={reusableStyles.boldText}>{Strings.IN_UNKNOWN_PROTOS_DP}</Text>
          {Strings.IN_UNKNOWN_PROTOS_SUGGESTION_2}
        </Text>

        <Text style={reusableStyles.normalSpacedText}>{Strings.IN_UNKNOWN_PROTOS_SUGGESTION_3}</Text>

        <View style={reusableStyles.subHeaderLine2} />

        <Text style={suggestionPagesStyles.pageTitle2}>{this.getPageTitle("outDiscardsNotZero")}</Text>

        <Text style={reusableStyles.centeredSubHeaderText}>{Strings.OUT_DISCARDS_SUGGESTION_1}</Text>
        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.normalSpacedText}>{Strings.OUT_DISCARDS_SUGGESTION_2}</Text>

        <View style={reusableStyles.subHeaderLine2} />

        <Text style={suggestionPagesStyles.pageTitle2}>{this.getPageTitle("outErrorsNotZero")}</Text>

        <Text style={reusableStyles.centeredSubHeaderText}>{Strings.OUT_ERRORS_SUGGESTION_1}</Text>
        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.normalSpacedText}>{Strings.OUT_ERRORS_SUGGESTION_2}</Text>
        <Text style={reusableStyles.normalSpacedText}>{Strings.OUT_ERRORS_SUGGESTION_3}</Text>
        <Text style={reusableStyles.normalSpacedText}>{Strings.OUT_ERRORS_SUGGESTION_4}</Text>

        <View style={reusableStyles.subHeaderLine2} />

        {this.getPageFooter()}

      </Page>
    );
  }

  // ----------------- Disclaimer -----------------
  createDisclaimerPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "30vh" }} />

        <Text style={reusableStyles.pageTitle}>{Strings.END_OF_REPORT}</Text>

        <View style={{ marginTop: "25vh" }} />

        <Text style={{
          fontSize: 14,
          fontFamily: "RobotoMedium",
          marginBottom: "5px"
        }}>
          {Strings.DISCLAIMER}
        </Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text
          style={{
            fontSize: 12,
            marginBottom: 2,
            fontFamily: "RobotoRegular",
            textAlign: "justify"
          }}>
          {Strings.DISCLAIMER_TEXT}
        </Text>

        {this.getPageFooter()}
      </Page >
    );
  }

  // ----------------- Lifecycle Methods ----------------
  render() {
    return (
      this.createReport()
    );
  }
}

const reusableStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 56
  },

  pageTitle: {
    textAlign: "center",
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  mainTitle: {
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  mainTitle2: {
    marginTop: "1vh",
    textAlign: "center",
    fontSize: 24,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  mainTitleUpperLine: {
    marginTop: "2vh",
    marginBottom: "2vh",
    marginLeft: "180px",
    height: "1px",
    width: "156px",
    backgroundColor: "black",
  },

  mainTitleBottomLine: {
    marginTop: "2vh",
    marginLeft: "206px",
    height: "1px",
    width: "100px",
    backgroundColor: "black",
  },

  subHeaderText: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  secondSubHeaderText: {
    marginTop: "2vh",
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  centeredSubHeaderText: {
    marginBottom: "1vh",
    fontSize: 14,
    fontFamily: "RobotoMedium",
    textAlign: "center",
  },

  centeredSecondSubHeaderText: {
    marginTop: "3vh",
    marginBottom: "1vh",
    fontSize: 14,
    fontFamily: "RobotoMedium",
    textAlign: "center"
  },

  subHeaderLine: {
    height: "1px",
    backgroundColor: "black",
    marginBottom: "2vh"
  },

  subHeaderLine2: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
  },

  normalText: {
    fontSize: 12,
    fontFamily: "RobotoRegular"
  },

  normalSpacedText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },

  boldText: {
    fontSize: 12,
    marginTop: "1vh",
    marginBottom: 4,
    fontFamily: "RobotoMedium"
  },

  lastInfoText: {
    fontSize: 12,
    marginBottom: "2vh",
    fontFamily: "RobotoRegular"
  },

  summaryText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },

  checkBox: {
    width: 12,
    height: 12,
    marginTop: "1vh",
    marginLeft: "20"
  },

  noErrorsUpperLineStyle: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "24vh",
  },

  noErrors: {
    marginTop: "4vh",
    textAlign: "center",
    fontSize: 18,
    marginBottom: "4vh",
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  }
});

const headerStyles = StyleSheet.create({
  container: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },

  logo: {
    width: "92pt",
    height: "30pt",
    marginBottom: "6pt"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "2vh"
  }
});

const footerStyles = StyleSheet.create({
  container: {
    textAlign: "right",
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoRegular"
  }
});

const suggestionPagesStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 110
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "3vh",
    fontFamily: "RobotoMedium"
  },

  pageTitle2: {
    fontSize: 18,
    marginTop: "4vh",
    marginBottom: "3vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  macTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  interfaceLabelTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  solvedTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  horaryTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  macTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  interfaceLabelTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  incrementTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  typeTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  solvedTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign: "center"
  },

  buttonImgStyle: {
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "1vh",
    marginBottom: "1vh",
    height: "32px",
    width: "180px"
  }

});

export default SuggestedActionsReport;
